import { Box } from "@mui/material";
import styles from "./style.module.css";
import Card from "./card";
import LoadingButton from "../../../../../components/loading/button";
import { useSelector } from "react-redux";

const GridResult = ({ projects }) => {
  const { isLoading } = useSelector((state) => state.projectFilters);

  return (
    <Box className={styles.result}>
      {projects.map((item) => (
        <Card key={item.project_id} project={item} />
      ))}
      {isLoading && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            width: "100%",
          }}
        >
          <LoadingButton />
        </Box>
      )}
    </Box>
  );
};

export default GridResult;
